import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=271a9f34&"
import script from "./colors.vue?vue&type=script&lang=js&"
export * from "./colors.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271a9f34')) {
      api.createRecord('271a9f34', component.options)
    } else {
      api.reload('271a9f34', component.options)
    }
    module.hot.accept("./colors.vue?vue&type=template&id=271a9f34&", function () {
      api.rerender('271a9f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/gantt/columnsConfigBar/components/dropdownOptions/colors.vue"
export default component.exports